import { React, useEffect, useState } from "react";
import { Link } from "react-router-dom";

import GradeCard from "./GradeCard";

import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import Card from "react-bootstrap/Card";
import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";

// import ViewQRDashLogins from "./ViewQRDashLogins"
import QRCodeGenerator from "./QRCodeGenerator";
import PrintAllLoginsButton from "./PrintAllLoginsButton";
import PaginationComponent from "./PaginationComponent";
import AlpacaInfoGesture from "../components/AlpacaInfoGesture";

import { getQR } from "../services/APIClient";
import NoteModal from "./NoteModal";

import "./QRClassCard.css";

function QRClassCard(props) {
  let classDetails = props.classDetails;
  let teachers = props.teachers || [];
  let teacherid = props.teacherid;
  let name = classDetails.name;
  let gradeLevel = classDetails.grade_level;
  let classid = classDetails.id;

  let gradeLevel1 = classDetails.grade_level1;
  let gradeLevel2 = classDetails.grade_level2;
  let gradeLevel3 = classDetails.grade_level3;
  let trialClass = classDetails.trial_class;

  console.log(classDetails, "CLASS DETAILS IN QR CLASS CARD");
  console.log(props, "props");


  // console.log(props)
  const [speechText, setSpeechText] = useState(null);
  const [modalShow, setModalShow] = useState(false);
  let [qrCodeDetails, setQRCodeDetails] = useState("");

  useEffect(() => {
    let isMounted = true; // Prevent updates on unmounted components
    getQR(classid).then((response) => {
      if (isMounted) {
        setQRCodeDetails(response); // Update QR code details only if the component is still mounted
      }
    });

    setSpeechText(
      `It looks like you still need to add students to your first classroom. Please go to "Classrooms" to do so.`
    );

    return () => {
      isMounted = false; // Cleanup to prevent updates on unmounted components
    };
  }, [classid]);

  // console.log(qrCodeDetails)

  return (
    // qrCodeDetails.length === 0 ? (
    //   <>
    //     <Col className="col-2">
    //     </Col>
    //     <Col className="alpaca-message-positioner">
    //       <AlpacaInfoGesture
    //         speechText={speechText}
    //       />
    //     </Col>
    //   </>
    // ) : (
    <>
      <Col className="col-4">
        <Card
          className={`${trialClass ? "trial-card-detail" : "card-detail"}`}
          onClick={() => setModalShow(true)}
        >
          <img
            src="./assets/imgs/Asset-class.webp"
            className="qr-class-card-img"
          ></img>
          <div>
            <GradeCard
              gradeLevel={gradeLevel}
              gradeLevel1={gradeLevel1}
              gradeLevel2={gradeLevel2}
              gradeLevel3={gradeLevel3}
              trialClass={trialClass}
            />
            {qrCodeDetails?.length > 0 ? (
              <p className="class-card-text">
                <img
                  src="./assets/imgs/child.png"
                  className="class-card-img"
                  alt="Student Image"
                />
                x {qrCodeDetails.length}
              </p>
            ) : (
              <>
                <br></br>
                <p className="class-card-text">
                  Please add students to your class
                </p>
              </>
            )}
          </div>
          <p
            className={`${trialClass ? "trial-class-card-text" : "class-card-text"
              }`}
          >
            {name}
          </p>
        </Card>
        <ViewLoginsModal
          show={modalShow}
          onHide={() => setModalShow(false)}
          name={name}
          classid={classid}
          qrCodeDetails={qrCodeDetails}
          teacherid={teacherid}
          teachers={teachers}
        />
      </Col>
    </>
  );
  // );
}

function ViewLoginsModal(props) {
  let name = props.name;
  let classid = props.classid;
  let qrCodeDetails = props.qrCodeDetails || []; // Ensure it's always an array
  let teacherid = props.teacherid;
  let teachers = props.teachers || [];

  // State to track selected students and total number of students
  const [selectedStudents, setSelectedStudents] = useState([]);
  const [totalStudents, setTotalStudents] = useState(qrCodeDetails.length);
  const [noteVersion, setNoteVersion] = useState(0);

  // By default, select all students when the modal opens
  useEffect(() => {
    if (Array.isArray(qrCodeDetails)) {
      const newSelectedStudents = qrCodeDetails.map((student) => student.id);
      setSelectedStudents(newSelectedStudents);
      setTotalStudents(qrCodeDetails.length); // Set the total number of students
    }
  }, [qrCodeDetails]);

  // Handle checkbox changes
  const handleCheckboxChange = (studentId) => {
    setSelectedStudents((prevSelected) => {
      if (prevSelected.includes(studentId)) {
        return prevSelected.filter((id) => id !== studentId);
      } else {
        return [...prevSelected, studentId];
      }
    });
  };

  // Sort the full list of students by name (alphabetical order)
  const sortedAllStudents = qrCodeDetails.sort((a, b) => {
    let nameA = a.name.toLowerCase();
    let nameB = b.name.toLowerCase();
    return nameA < nameB ? -1 : nameA > nameB ? 1 : 0;
  });

  // Filter the list of students to include only the selected ones
  const filteredQRDetails = qrCodeDetails.filter((student) =>
    selectedStudents.includes(student.id)
  );

  // Pagination logic for the filtered and sorted list
  const [itemsPerPage] = useState(6); // Pagination set for 6 QR codes per page
  const [currentPage, setCurrentPage] = useState(1);
  const startItemIndex = (currentPage - 1) * itemsPerPage;
  const endItemIndex = startItemIndex + itemsPerPage;
  const currentItems = filteredQRDetails.slice(startItemIndex, endItemIndex);

  const handlePageClick = (selectedPage) => {
    setCurrentPage(selectedPage);
  };

  console.log("Selected Students:", selectedStudents);
  console.log("Total Students:", totalStudents);
  console.log("Filtered QR Details:", filteredQRDetails);
  console.log("Current Items:", currentItems);

  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header>
        <Modal.Title id="contained-modal-title-vcenter" className="text-center">
          {name} Student Logins
        </Modal.Title>
        {/* Class-level note button removed — student notes only
        <div style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          border: '2px solid #1a56db',
          borderRadius: '8px',
          padding: '4px 8px',
          backgroundColor: '#eef2ff',
          gap: '2px',
          marginLeft: 'auto',
          marginRight: '8px',
        }}>
          <NoteModal
            entityName={name}
            elementtype="class"
            elementid={classid}
            noteType="QR Code"
            teacherid={teacherid}
            teachers={teachers}
          />
          <span style={{ fontSize: '10px', color: '#1a56db', fontWeight: '600', lineHeight: 1 }}>Notes</span>
        </div>
        */}
      </Modal.Header>
      <Row className="p-3">
        <Col xs={12}>
          <div className="d-flex justify-content-between align-items-center mb-2">
            <Form.Check
              type="checkbox"
              id="select-all"
              label="Select All"
              checked={
                selectedStudents.length === sortedAllStudents.length &&
                sortedAllStudents.length > 0
              }
              onChange={(e) => {
                if (e.target.checked) {
                  setSelectedStudents(sortedAllStudents.map((s) => s.id));
                } else {
                  setSelectedStudents([]);
                }
              }}
            />
          </div>
          <div className="student-selection-list">
            <div
              style={{
                maxHeight: "200px",
                overflowY: "scroll",
                paddingRight: "15px",
              }}
            >
              {/* Render all students but check only the selected ones */}
              {sortedAllStudents.map((student) => (
                <Card key={student.id} className="mb-2">
                  <Card.Body className="d-flex justify-content-between align-items-center">
                    <Form.Check
                      type="checkbox"
                      checked={selectedStudents.includes(student.id)}
                      onChange={() => handleCheckboxChange(student.id)}
                      label={student.name}
                    />
                  </Card.Body>
                </Card>
              ))}
            </div>
          </div>
        </Col>
      </Row>

      <Modal.Body>
        <Row>
          {/* Check if there are no students in the classroom */}
          {totalStudents === 0 ? (
            <>
              <h4>There are currently no students in this classroom.</h4>
              <h4>
                Please go to "Classrooms" in order to add
                students to this class.
              </h4>
            </>
          ) : selectedStudents.length === 0 ? (
            /* Check if students exist but none are selected */
            <h4>
              Please select at least one student to view and print their QR
              codes.
            </h4>
          ) : (
            /* Render QR codes for selected students */
            currentItems
              .filter((student) => selectedStudents.includes(student.id))
              .map((student) => (
                <QRCodeGenerator key={student.id} student={student}>
                  <NoteModal
                    entityName={student.name}
                    elementtype="student"
                    elementid={student.studentid}
                    noteType="QR Code"
                    teacherid={teacherid}
                    teachers={teachers}
                    onSuccess={() => setNoteVersion((v) => v + 1)}
                    filterByNoteType={true}
                  />
                </QRCodeGenerator>
              ))
          )}
          <br />
          {/* Show pagination only if the number of filtered students exceeds the items per page */}
          {filteredQRDetails.length > itemsPerPage && (
            <PaginationComponent
              itemsPerPage={itemsPerPage}
              totalItems={filteredQRDetails.length}
              handlePageClick={handlePageClick}
            />
          )}
        </Row>
      </Modal.Body>
      <Modal.Footer>
        {selectedStudents.length > 0 && (
          <PrintAllLoginsButton
            name={name}
            label="Print Selected QR Codes"
            qrCodeDetails={filteredQRDetails}
            classid={classid}
            teachers={teachers}
            noteVersion={noteVersion}
          />
        )}
        <button className="white-button" onClick={props.onHide}>
          Close
        </button>
      </Modal.Footer>
    </Modal>
  );
}

export default QRClassCard;
